module.exports = __webpack_public_path__ + "svg/cogs.026eb51.svg";